import { Ecommerce, Taxonomy } from 'shared/tracking/contracts';
import { mapTracking } from './mapTracking';

export const trackPage = (taxonomy: Taxonomy, ecommerce?: Ecommerce) => {
    const eventData = mapTracking(taxonomy, ecommerce);

    if (!eventData) return;

    window.analytics?.page(taxonomy.page, eventData);
    window.analytics?.track('Viewed Page', eventData);
};
